var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAssetKuroModalDesktopPlaceholderIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.364,
    height: 37.432,
    viewBox: "0 0 44.364 37.432",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_120",
    "data-name": "Group 120",
    transform: "translate(-128 -308)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "tv-music",
    d: "M44.364,33.817V6.679A4.656,4.656,0,0,0,39.743,2H4.621A4.657,4.657,0,0,0,0,6.679V33.817H21.258V37.56H12.939v1.872H31.424V37.56H23.106V33.817ZM1.848,6.679A2.794,2.794,0,0,1,4.621,3.872H39.743a2.794,2.794,0,0,1,2.773,2.807V31.945H1.848Z",
    transform: "translate(128 306)",
    fill: "#d9d9d9"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetKuroModalDesktopPlaceholderIcon);
export default __webpack_public_path__ + "static/media/Asset-KuroModalDesktopPlaceholderIcon.f0712cc146e7e91b12d17647673e4493.svg";
export { ForwardRef as ReactComponent };